import React, { Fragment, useContext } from "react";
import styled from "styled-components";
import { useTransition } from "react-spring";
import { HeaderDropdownContext } from "components/HeaderDropdown/HeaderDropdown";
import { AnimatedWrapper } from "components/Dropdown";

type Props = {
  children: React.ReactNode;
  alignment: "left" | "right";
};

export const HeaderDropdownMenuBox = ({ children, alignment }: Props) => {
  const { isDropdownOpen } = useContext(HeaderDropdownContext);

  const transition = useTransition(isDropdownOpen, null, {
    from: { transform: "translate3d(0, -10px, 0)", opacity: 0 },
    enter: { transform: "translate3d(0, 0, 0)", opacity: 1 },
    leave: { transform: "translate3d(0, -10px, 0)", opacity: 0 },
  });

  const getAlignment = () => {
    switch (alignment) {
      case "left":
        return { left: "-7px" };
      case "right":
        return { right: "-7px" };
      default:
        return {};
    }
  };

  return (
    <Fragment>
      {transition.map(
        ({ item, key, props: style }) =>
          item && (
            <AnimatedWrapper key={key} style={{ ...style, ...getAlignment() }}>
              <StyledBox>{children}</StyledBox>
            </AnimatedWrapper>
          )
      )}
    </Fragment>
  );
};

const StyledBox = styled("div")`
  display: flex;
  position: relative;
  flex-direction: column;
  background-color: #ffffff;
  box-shadow: 0 0 5px #00000026;
  border-radius: 5px;
  opacity: 1;
  overflow: hidden;
`;
